// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"c904242f","213":"ba69e365","239":"0248cd7a","422":"88ec5299","455":"476060b9","884":"ede21be3"}[chunkId] + ".chunk.js";
};